import React, { useContext, useState } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { CommonReload } from '../filter/CommonReload';
import FreeSelectMonth from '../filter/FreeSelectMonth';
import { FontAwesome } from '@expo/vector-icons';
import { DailyReportHeaderContext } from '../../navigation/tabStack/DailyReportTabStack';
import Modal from '@material-ui/core/Modal';
import { Button, Paper } from '@material-ui/core';
import DailyReportSelectMember from '../dailyReport/DailyReportSelectMember';
import { DailyReportMemberModel } from '../../models/DailyReport/DailyReportMemberModel';
import NotificationToast from '../common/NotificationToast';
import HomeIcon from '@material-ui/icons/Home'; // 例: 家のアイコン
import BusinessIcon from '@material-ui/icons/Business'; // 例: 会社のアイコン
import DailyReportSelectExternalMember from '../dailyReport/DailyReportSelectExternalMember';
import {
  DailyReportsExternalMember,
  DailyReportsExternalMemberModel,
} from '../../models/DailyReport/DailyReportsExternalMemberModel';

const DailyReportHeader = (props: any) => {
  const modalStyle: React.CSSProperties = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)', // これを追加してモーダルを中央に配置する
    width: '95%', // 必要に応じて調整してください（100%だと画面いっぱいになるので注意）
    height: 'auto',
    backgroundColor: 'white',
    padding: 5,
    overflowY: 'auto',
    boxSizing: 'border-box', // パディングやボーダーがwidth・heightに含まれるようにする
  };

  const { onReload } = useContext(DailyReportHeaderContext);
  const [isMemberModalOpen, setMemberModalOpen] = useState(false);
  const [isExternalMemberModalOpen, setExternalMemberModalOpen] = useState(false);

  /**モーダルの表示・非表示 */
  const openMemberModal = () => setMemberModalOpen(true);
  const closeMemberModal = () => setMemberModalOpen(false);

  const openExternalMemberModal = () => setExternalMemberModalOpen(true);
  const closeExternalMemberModal = () => setExternalMemberModalOpen(false);

  const onHandleReload = () => {
    onReload();
  };

  /**
   * 指定のメンバーを日報メンバーに登録する
   * @param {number[]} member_ids メンバーのID
   * @returns {Promise<void>}
   */
  const saveMembers = async (member_ids: number[]) => {
    closeMemberModal();
    try {
      await DailyReportMemberModel.save({ other_user_ids: member_ids });
      NotificationToast().saved();
    } catch (error) {
      NotificationToast().error('登録に失敗しました。');
    }
  };

  const saveExternalMembers = async (members: DailyReportsExternalMember[]) => {
    closeExternalMemberModal();
    try {
      await DailyReportsExternalMemberModel.save({ members: members });
      NotificationToast().saved();
    } catch (error) {
      NotificationToast().error('登録に失敗しました。');
    }
  };

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      {/* <FreeSelectMonth /> */}
      <Button
        variant="contained"
        color="primary"
        onClick={openMemberModal}
        startIcon={<HomeIcon style={{ fontSize: 20 }} />}
        style={{
          borderRadius: 8, // 角度を丸くするためのスタイル
          textTransform: 'none', // テキストの大文字化を解除するためのスタイル
        }}
      >
        報告(社内)
      </Button>
      <Button
        variant="contained"
        color="secondary" // 例: 色をセカンダリーカラーに変更
        onClick={openExternalMemberModal}
        startIcon={<BusinessIcon style={{ fontSize: 20 }} />}
        style={{
          marginLeft: 10,
          borderRadius: 8, // 角度を丸くするためのスタイル
          textTransform: 'none', // テキストの大文字化を解除するためのスタイル
        }}
      >
        報告(社外)
      </Button>

      <TouchableOpacity onPress={onHandleReload} style={{ paddingLeft: 10, paddingRight: 10 }}>
        <FontAwesome name="repeat" size={28} color="#aaa" />
      </TouchableOpacity>

      {/* メンバー選択モーダル */}
      <Modal open={isMemberModalOpen} onClose={closeMemberModal}>
        <Paper style={modalStyle}>
          <DailyReportSelectMember onSave={saveMembers} />
        </Paper>
      </Modal>
      <Modal open={isExternalMemberModalOpen} onClose={closeExternalMemberModal}>
        <Paper style={modalStyle}>
          <DailyReportSelectExternalMember onSave={saveExternalMembers} />
        </Paper>
      </Modal>
    </View>
  );
};

export default DailyReportHeader;
